/**
 * Normalizes a raw conversation identifier to the impression key. Every "not yet persisted" value
 * (`null`, `undefined`, empty string, or the literal `"new"`) collapses to `null` so a virtual
 * greeting and its persisted form share one virtual key until a real conversation id appears.
 */
export function normalizeGreetingConversationKey(conversationId) {
    if (!conversationId || conversationId === "new") {
        return null;
    }
    return conversationId;
}
/**
 * View-transition rule for the greeting-audio impression event.
 *
 * A view is `{ characterId, conversationKey }`. An impression fires on every transition into a new
 * view except two:
 * - the identical view (re-renders while sitting in the same chat), and
 * - an unsaved conversation being persisted for the same character (`null` -> real id), which is
 *   the same greeting bubble simply gaining a server id, not a new view.
 */
export default function shouldEmitGreetingImpression({ previousView, nextView }) {
    if (!nextView.characterId) {
        return false;
    }
    if (!previousView) {
        return true;
    }
    if (previousView.characterId !== nextView.characterId) {
        return true;
    }
    if (previousView.conversationKey === nextView.conversationKey) {
        return false;
    }
    // Only suppressed change for the same character: an unsaved conversation being persisted.
    return !(previousView.conversationKey === null && nextView.conversationKey !== null);
}
